import { QRCodeSVG } from 'qrcode.react';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import html2canvas from 'html2canvas';
import { ButtonPrimary } from '@americanexpress/dls-react';
import { BalanceContext } from '../context';
import { getPayNowLogoBase64 } from '../../assets/assets';
import { parseHtml } from '../../utils/util';

const crc = require('crc');

let cardNum;

function downloadURI(uri, name) {
  const link = document.createElement('a');
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

async function PrintDiv() {
  const imageElement = document.querySelector('#QrCodeImage');
  const canvas = await html2canvas(imageElement);
  const myImage = canvas.toDataURL('image/png');
  downloadURI(myImage, 'QrCode.png');
}

function generatePaynowQrCodeForSingapore(props) {
  /**
     Generate Dynamic QR Code for Singapore for Pay Now
     */

  /** Create the ASCII value */
  const { amtPay, toShow, listNodes } = props;
  let lenAmtPay = Object.keys(amtPay).length;
  let transAmt;
  /* eslint-disable no-lonely-if -- need */
  if ((lenAmtPay % 2) === 1) {
    lenAmtPay += 1;
    if (lenAmtPay <= 9) {
      transAmt = `540${lenAmtPay}0${amtPay}`;
    } else {
      transAmt = `54${lenAmtPay}0${amtPay}`;
    }
  } else {
    if (lenAmtPay <= 9) {
      transAmt = `540${lenAmtPay}${amtPay}`;
    } else {
      transAmt = `54${lenAmtPay}${amtPay}`;
    }
  }
  /* eslint-enable no-lonely-if -- need */
  const billNum = `01${Object.keys(cardNum).length}${cardNum}`;
  const addDtlField = `62${Object.keys(billNum).length}${billNum}`;
  let dynamicQr = '0';
  if (Number.parseInt(amtPay, 10) === 0) {
    dynamicQr = '1';
  }
  const asciiCodeWoCheckSum = `00020101021226400009SG.PAYNOW010120213S68FC1878JAXP0301${dynamicQr}520400005303702${transAmt
  }5802SG5935AMERICAN EXPRESS INTERNATIONAL INC.6009SINGAPORE${addDtlField}`;

  /** Generate the CRC */
  const checksum = crc.crc16ccitt(`${asciiCodeWoCheckSum}6304`)
    .toString(16)
    .toUpperCase();
  const asciiCode = `${asciiCodeWoCheckSum}6304${checksum}`;

  const paynowLogoBase64 = getPayNowLogoBase64();

  /** Return the QR */
  return (
    <div className="row">
      {
        toShow && (
          <div className="col-md-4 col-md-offset-3 text-align-center">
            <p className="margin-1-tb">Payment Amount: ${amtPay}</p>
            <div>
              <div id="QrCodeImage" className="margin-2-b">
                <QRCodeSVG
                  value={asciiCode}
                  size={130}
                  fgColor="#7c1a78"
                  level="H"
                  imageSettings={{
                    src: `${paynowLogoBase64}`,
                    height: 32,
                    width: 43,
                    x: undefined,
                    y: undefined,
                    excavate: true,
                  }}
                />
              </div>
              <ButtonPrimary type="button" size="md" id="PrintDiv" onClick={PrintDiv}>Download QR Code</ButtonPrimary>
            </div>
          </div>
        )
      }
      {
        listNodes && listNodes.length > 0 && (
        <div className="col-md-5">
          {
            listNodes.map((node, index) => (<p className={node.style} key={`node${index + 1}`}> {parseHtml(node.value)}</p>))
          }
        </div>
        )
      }
    </div>
  );
}

function generateUpiQrCodeForIndia(balanceContextVal, amtPay, toShow) {
  const upiID = `aebcXXXXXXXXXX${cardNum.slice(-4)}@sc`;
  const upiURL = `upi://pay?cu=INR&pa=${balanceContextVal.upiId}&pn=American%20Express&am=${amtPay}`;

  return (
    <div
      className={`col-md-12 pad-1-lr text-align-center margin-2-b ${toShow ? 'display-block' : 'display-none'
      }`}
    >
      <p>Paying Amount: ₹{amtPay}</p>
      <p>{upiID}</p>
      <QRCodeSVG value={upiURL} size={130} />
      <p>
        Scan QR Code to make payment, <a href={upiURL}>click here</a> if using
        mobile.
      </p>
    </div>
  );
}

const QrCode = ({
  cardNumber,
  amtPay,
  otherAmtValue,
  market,
  listNodes,
}) => {
  const balanceContextVal = useContext(BalanceContext);
  let toShow = Boolean(amtPay);
  if (amtPay === 'other') {
    if (otherAmtValue !== '') {
      amtPay = otherAmtValue;
    } else {
      toShow = false;
    }
  }

  if (Number.parseInt(amtPay, 10) === 0) {
    toShow = false;
  }
  if (cardNumber) {
    cardNum = cardNumber ? cardNumber.replace(/-/g, '') : cardNumber;
  } else {
    cardNum = balanceContextVal.upiId.replace(/\D/g, '');
  }

  if (market === 'IN') {
    return generateUpiQrCodeForIndia(balanceContextVal, amtPay, toShow);
  }
  if (market === 'SG') {
    return generatePaynowQrCodeForSingapore({ amtPay, toShow, listNodes });
  }
  return true;
};

QrCode.propTypes = {
  cardNumber: PropTypes.objectOf(PropTypes.shape),
  amtPay: PropTypes.string,
  otherAmtValue: PropTypes.objectOf(PropTypes.shape),
};

export default QrCode;
